import { getRoutingBase } from '@/utils/getEnvVars'
import { compileDestinations, page, params, query, surface } from '@sevenrooms/navigation'

const getDynamicRoutingBase = (param: string) =>
  window.location.pathname?.startsWith('/explore') ? `explore/${param}/reservations/` : `app/${getRoutingBase()}/${param}/`

export const routes = compileDestinations(
  page(
    '/',
    []
  )({
    reservations: page(params => getDynamicRoutingBase(params.venueKey), [], {
      venueKey: params.string,
      lang: query.optional.string,
      tracking: query.optional.string,
      utm_source: query.optional.string,
      utm_medium: query.optional.string,
      utm_campaign: query.optional.string,
      utm_content: query.optional.string,
      utm_id: query.optional.string,
      utm_term: query.optional.string,
      fbclid: query.optional.string,
      date: query.optional.string,
      start_time: query.optional.string,
      halo: query.optional.string,
      end_time: query.optional.string,
      party_size: query.optional.string,
      venues: query.optional.string,
      timeslot_id: query.optional.string,
      timeslot_time: query.optional.string,
      timeslot_experience_id: query.optional.string,
      primary_venue_id: query.optional.string, // Should only be used in Create flow
      client_id: query.optional.string,
      referral: query.optional.string,
      request_id: query.optional.string,
      channel: query.optional.string,
      _ga: query.optional.string,
      _gl: query.optional.string,
      instant_experiences_enabled: query.optional.string,
      error_display: query.optional.string,
      error_message: query.optional.string,
      client_token: query.optional.string,
      duration_picker: query.optional.string,
      duration: query.optional.string,
      searchTab: query.optional.string,
      hideTabs: query.optional.string,
      hideAddress: query.optional.string,
      devMode: query.optional.string,
      v_id: query.optional.string,
      sessionid: query.optional.string,
      distinctid: query.optional.string,
    })({
      create: page(
        () => 'create/',
        [],
        {}
      )({
        search: page(() => 'search/', [], {}),
        upgrades: page(() => 'upgrades/', [], {}),
        checkout: page(() => 'checkout/', [], {}),
      }),
      modify: page(() => 'modify/', [], { token: query.string })({
        search: page(() => 'search/', [], {}),
        upgrades: page(() => 'upgrades/', [], {}),
        checkout: page(() => 'checkout/', [], {}),
      }),
      prearrival: page(
        () => 'prearrival/',
        [],
        {}
      )({
        upgrades: page(() => 'upgrades/', [], {}),
        checkout: page(() => 'checkout/', [], {}),
      }),
      search: page(() => 'search/', [], {}),
      errorModal: surface('error-modal/', []),
      manage: page(() => 'manage/', [], {
        token: query.string,
        is_confirm: query.optional.string,
        is_success: query.optional.string,
        is_success_edit: query.optional.string,
        marketing_opt_in: query.optional.string,
      })({
        passed: page('passed', []),
        canceled: page('canceled', []),
        modifyModal: surface('modify-modal/', []),
        cancelModal: surface('cancel-modal/', []),
        errorUpgrades: surface('error-upgrades-modal/', []),
        addUpgradesModal: surface('add-upgrades-modal/', []),
      }),
      alerts: page(
        () => 'alerts/',
        [],
        {}
      )({
        canceled: page('canceled', []),
      }),
    }),
    legacyReservations: page(params => `reservations/${params.venueKey}/${params.trackingSlug}`, [], {
      venueKey: params.string,
      trackingSlug: params.optional.string,
      venues: params.optional.string,
      modify_res: query.optional.string,
      modify_upgrades: query.optional.string,
      default_date: query.optional.string,
      default_time: query.optional.string,
      default_party_size: query.optional.string,
      client_id: query.optional.string,
      duration_picker: query.optional.string,
      _ct: query.optional.string,
      lang: query.optional.string,
      token: query.optional.string,
      request_id: query.optional.string,
      experience_id: query.optional.string,
      max_days_out: query.optional.string,
      waitlist_id: query.optional.string,
      referral_id: query.optional.string,
    }),
    direct: page(
      'direct/',
      []
    )({
      modifyReservation: page(params => `modify-reservation/${params.token}`, [], {
        token: params.optional.string,
        lang: query.string,
        modify_upgrades: query.optional.string,
      }),
      chargeReceipt: page(params => `receipt/${params.billingHistoryId}/`, [], {
        lang: query.string,
        billingHistoryId: params.string,
      }),
    }),
  })
)
